import React, { useState } from "react";
import useClassSelection from "./useClassSelection";
import useAcademicYearOptions from "../../utils/useAcademicYearOptions";
import NewClassInsightsTab from "./NewClassInsightsTab";
import ScreeningPointTab from "./ScreeningPointTab";
import PTMTab from "./PTMTab";
import "./EnhancedAIReports.css";

export const ENHANCED_REPORT_KEYS = {
  NEW_CLASS_INSIGHTS: "new_class_insights",
  SCREENING_POINT: "screening_point",
  PTM_PARENT_HANDOUT: "ptm_parent_handout",
};

const VALID_REPORTS = new Set(Object.values(ENHANCED_REPORT_KEYS));

export function getRequestedReport(searchParams) {
  const requestedReport = searchParams.get("report");
  return VALID_REPORTS.has(requestedReport)
    ? requestedReport
    : ENHANCED_REPORT_KEYS.NEW_CLASS_INSIGHTS;
}

function EnhancedAIReportsPanel({ report, title, subheading }) {
  const yearOptions = useAcademicYearOptions({ previousYears: 1, futureYears: 1 });
  const defaultYear = yearOptions[1]?.storage || yearOptions[0]?.storage || "";
  const [screeningPointYear, setScreeningPointYear] = useState(defaultYear);
  const [ptmYear, setPtmYear] = useState(defaultYear);

  const activeYearOverride =
    report === ENHANCED_REPORT_KEYS.SCREENING_POINT
      ? screeningPointYear
      : report === ENHANCED_REPORT_KEYS.PTM_PARENT_HANDOUT
      ? ptmYear
      : undefined;
  const selection = useClassSelection(activeYearOverride);

  return (
    <div className="enhanced-reports-panel">
      {report === ENHANCED_REPORT_KEYS.NEW_CLASS_INSIGHTS && (
        <NewClassInsightsTab
          selection={selection}
          title={title}
          subheading={subheading}
        />
      )}
      {report === ENHANCED_REPORT_KEYS.SCREENING_POINT && (
        <ScreeningPointTab
          selection={selection}
          yearOptions={yearOptions}
          academicYear={screeningPointYear}
          onAcademicYearChange={setScreeningPointYear}
          title={title}
          subheading={subheading}
        />
      )}
      {report === ENHANCED_REPORT_KEYS.PTM_PARENT_HANDOUT && (
        <PTMTab
          selection={selection}
          yearOptions={yearOptions}
          academicYear={ptmYear}
          onAcademicYearChange={setPtmYear}
          title={title}
          subheading={subheading}
        />
      )}
    </div>
  );
}

export default EnhancedAIReportsPanel;
